import {call, take, select} from 'redux-saga/effects';
import getSocialBridge from '../../bridges/socialBridge';
import {PLATFORMS} from 'epic-node-services/src/account/SocialUtils';

export function* untilSet(
    selector,
    awaitAction = '*' /*, onMissingAction = null, onMissingParams = []*/
) {
    let val = yield select(selector);
    if (val) return val;
    // if (onMissingAction) yield put(onMissingAction, ...onMissingParams);
    while (true) {
        yield take(awaitAction);
        val = yield select(selector);
        if (val) {
            return val;
        }
    }
}

export function* validateUnlinkedSocialPlatforms(unlinkedPlatforms) {
    if (!unlinkedPlatforms || !unlinkedPlatforms.length) return [];
    const validPlatforms = [];
    for (let i = 0; i < unlinkedPlatforms.length; i++) {
        const platform = unlinkedPlatforms[i];
        if (platform === PLATFORMS.STEAM) {
            const hasAccount = yield call(getSocialBridge().hasThirdPartyAccounts, platform);
            if (hasAccount) {
                validPlatforms.push(platform);
            }
        } else {
            validPlatforms.push(platform);
        }
    }
    return validPlatforms;
}

export const getErrorMessages = errors => {
    return errors && errors.length && errors.map(x => x.message || x).join(', ');
};
